import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start gap-4 w-full animate-slideFadeIn" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = { class: "flex gap-2 w-full pt-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex w-full items-center justify-center" }

import { ref } from "vue"
import { useStore } from "vuex"
import { useForm, useField } from "vee-validate"
import * as Yup from "yup"

import { countries } from "@/core/helpers"
import CustomSelect from "../auth/CustomSelect.vue"
import FormInput from "../auth/FormInput.vue"
import router from "@/router"


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneStep',
  props: {
    canGoBack: { type: Boolean }
  },
  emits: ["next", "back"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit


const store = useStore()
const isLoading = ref(false)


const countryOptions = countries.map((item: any) => ({
    label: `+${item.prefix}`,
    value: String(item.prefix),
    icon: require("@/assets/images/countries/" + item.icon + ".svg"),
    searchLabel: `${item.label} +${item.prefix}`
}))

const selectedOption = ref(
    countryOptions.find((c) => c.value === "216") || countryOptions[0]
)

const schema = Yup.object({
    phone: Yup.string()
        .required("Phone number is required")
        .matches(/^[0-9]+$/, "Phone must contain only numbers")
        .min(8, "Phone number is too short"),

    phone_prefix: Yup.string().required()
})

const { handleSubmit, meta } = useForm({
    validationSchema: schema
})

const {
    value: phone,
    errorMessage: phoneError,
    meta: phoneMeta
} = useField<string>("phone", undefined, {
    initialValue: store.state.authOnboarding.phone || ""
})

const { value: phonePrefix } = useField<string>("phone_prefix", undefined, {
    initialValue: selectedOption.value.value
})


const onPrefixSelect = (opt: any) => {
    selectedOption.value = opt
    phonePrefix.value = opt.value
}

const sanitizePhone = (e: Event) => {
    const input = e.target as HTMLInputElement
    phone.value = input.value.replace(/\D/g, "")
}

const restrictToNumbers = (e: KeyboardEvent) => {
    const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab"
    ]

    if (
        allowedKeys.includes(e.key) ||
        (e.ctrlKey || e.metaKey)
    ) {
        return
    }

    if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault()
    }
}

const onSubmit = handleSubmit(() => {
    isLoading.value = true

    store.commit("authOnboarding/SET_PHONE", {
        phone: phone.value,
        phone_prefix: phonePrefix.value
    })

    isLoading.value = false
    emit("next")
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.canGoBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back'))),
            class: "flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "←", -1),
            _createElementVNode("span", null, "Back", -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex flex-col gap-2" }, [
      _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-700" }, " What’s your phone number? "),
      _createElementVNode("p", { class: "text-sm text-gray-400 font-medium" }, " Used for account security and campaign communication. Never shared publicly. ")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CustomSelect, {
        name: "phone_prefix",
        options: _unref(countryOptions),
        modelValue: selectedOption.value,
        "onUpdate:modelValue": onPrefixSelect,
        searchable: ""
      }, null, 8, ["options", "modelValue"]),
      _createVNode(FormInput, {
        modelValue: _unref(phone),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(phone) ? (phone).value = $event : null)),
        type: "tel",
        inputmode: "numeric",
        placeholder: "00000000",
        error: _unref(phoneMeta).touched ? _unref(phoneError) : '',
        onInput: sanitizePhone,
        onKeydown: restrictToNumbers
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("button", {
      disabled: !_unref(meta).valid || isLoading.value,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
      class: "w-full mt-6 bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-3 rounded-xl disabled:opacity-40 disabled:cursor-not-allowed"
    }, " Continue ", 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/auth/choose'))),
        class: "flex items-center gap-2 text-sm text-gray-500 hover:text-purple-500 hover:underline transition"
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("span", null, " Back to Sign up", -1)
      ]))])
    ])
  ]))
}
}

})